import addParam from '../addParam'

/**
 * uin，skey登录态
 * @param opt.uin qq号
 * @param opt.pskey 登录态的pskey
 */
export default class {
  constructor(opt) {
    if (!opt.uin || !opt.pskey) {
      console.error("session_pskey need uin,pskey,sessiontype params");
    }
		/**
		 * QQ号
		 */
    this.uin = opt.uin;
		/**
		 * session id
		 */
    this.pskey = opt.pskey;
		/**
		 * session type
		 */
    this.sessiontype = opt.sessiontype;
  }

  getSessionParam() {
    return {
      openid: String(this.uin),
      openkey: encodeURIComponent(this.pskey),
      session_id: 'uin',
      session_type: this.sessiontype
    };
  }

  addSessionParam(url) {
    return addParam({
      openid: encodeURIComponent(this.uin),
      openkey: encodeURIComponent(this.pskey),
      sessionid: 'uin',
      sessiontype: this.sessiontype
    }, url);
  }

  //注意，这个函数是必须的
  getUin() {
    return this.uin;
  }
}
